import { getPortalRuntimeConfig } from '../services/runtimeConfig';

export default function getEnvironment() {
  const { env, envName: configEnvName } = getPortalRuntimeConfig();

  if (env === 'preview') {
    return {
      isProd: false,
      isLocal: false,
      get envName() {
        return configEnvName ?? window?.location?.hostname?.split('.')?.[0] ?? 'preview';
      },
    };
  }

  if (env === 'local') {
    return {
      isProd: false,
      isLocal: true,
      envName: configEnvName ?? 'local',
    };
  }

  if (env === 'dev') {
    return {
      isProd: false,
      isLocal: false,
      envName: configEnvName ?? 'dev',
    };
  }

  return {
    isProd: true,
    isLocal: false,
    envName: configEnvName ?? 'prod',
  };
}

// Helper function to get environment summary (can be called from browser console)
// Only available in non-production environments for security
export const getEnvironmentSummary = () => {
  const env = getEnvironment();

  // Only expose in non-production environments
  if (env.isProd) {
    console.warn('Environment summary not available in production for security reasons');
    return { environment: 'production', debug: false };
  }

  const { env: runtimeEnv, envName: runtimeEnvName, isPreview } = getPortalRuntimeConfig();
  const summary = {
    detectedEnvironment: env,
    runtimeConfig: {
      env: runtimeEnv,
      envName: runtimeEnvName,
      isPreview,
    },
  };

  console.log('🔍 Environment Summary:', summary);
  return summary;
};

// Make available globally only in non-production
if (typeof window !== 'undefined') {
  const env = getEnvironment();
  if (!env.isProd) {
    (window as any).getEnvironmentSummary = getEnvironmentSummary;
  }
}
